module.exports = __webpack_public_path__ + "img/icon_video_interativo_hover.5865229f.png";